import React, { useEffect, useState } from "react";
import {
  Descriptions,
  List,
  Divider,
  Modal,
  Button,
  Drawer,
  Result,
  Layout,
  Radio,
  Tag,
  Flex,
  TreeSelect,
  Grid,
  Segmented,
  Tabs,
  Card,
  Image,
  Typography,
  Row,
  Col,
  theme,
  Space,
} from "antd";
import {
  BarsOutlined,
  ZoomInOutlined,
  AppstoreOutlined,
  FireTwoTone,
} from "@ant-design/icons";

import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import BuyerListProduct from "../../components/BuyerListProduct";
import Cart from "../../components/Cart";
import BuyerListOrder from "../../components/BuyerListOrder";
import BuyerListBill from "../../components/BuyerListBill";
import BuyerListInvoice from "../../components/BuyerListInvoice";
import CartButton from "../../components/CartButton";
import SearchProduct from "../../components/Search";
import Navbar from "../../components/Navbar";
import OrderEditMessage from "../../components/SellerEditOrderView";
import SellerBuyerView from "../../components/SellerBuyerView";
import PagesFooter from "../../components/PagesFooter";
import { axiosClient } from "../../apiClient";
import { gold } from "@ant-design/colors";

const { Content } = Layout;
const { useToken } = theme;
const { useBreakpoint } = Grid;
const { Text } = Typography;

const PromoTabs = React.memo(
  ({
    activeTab,
    setActiveTab,
    campaigns,
    defaultFilters,
    token,
    dispatch,
    setFeaturedCampaign,
  }) => {
    return (
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        tabBarGutter={8}
        tabBarStyle={{ margin: 0, padding: "4px 0px" }}
      >
        {[
          ...defaultFilters,
          ...(campaigns ?? [])
            .filter((rule) =>
              ["progressiveDiscount", "discountProducts"].includes(rule.action),
            )
            .map((rule) => ({
              ...rule,
              filterType: `campaign_${rule.id}`,
              icon: (
                <FireTwoTone twoToneColor={gold[5]} style={{ fontSize: 24 }} />
              ),
            })),
        ].map((camp) => {
          const isDefaultFilter = !camp.filterType.startsWith("campaign_");
          const isActive = activeTab === camp.filterType;

          return (
            <Tabs.TabPane
              key={camp.filterType}
              tab={
                <Card
                  hoverable
                  onClick={() => {
                    dispatch({
                      type: "SET_FILTER_TYPE",
                      filterType: camp.filterType,
                    });
                    setActiveTab(camp.filterType);
                  }}
                  style={{
                    width: isDefaultFilter ? 140 : 300,
                    height: 60,
                    margin: 0,
                    padding: 0,
                    backgroundColor: isActive
                      ? `${token.colorPrimaryBgHover}65`
                      : token.colorBgContainer,
                    transition: "background-color 0.3s",
                  }}
                  styles={{
                    body: {
                      padding: 0,
                      margin: 0,
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    },
                    header: { display: "none" },
                    actions: { display: "none" },
                    cover: { display: "none" },
                  }}
                >
                  {isDefaultFilter ? (
                    <Space direction="vertical">
                      <Text type="secondary">{camp.name}</Text>
                      <Text strong>{camp.value}</Text>
                    </Space>
                  ) : (
                    <>
                      <Row
                        gutter={8}
                        style={{ width: "100%", margin: 0, padding: 0 }}
                        align="middle"
                      >
                        <Col>
                          <div
                            onClick={() => setFeaturedCampaign(camp)}
                            style={{
                              width: 40,
                              height: 40,
                              borderRadius: 4,
                              background: token.colorBgLayout,
                              cursor: "pointer",
                              position: "relative",
                              overflow: "hidden",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.querySelector(
                                ".mask",
                              ).style.opacity = 1)
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.querySelector(
                                ".mask",
                              ).style.opacity = 0)
                            }
                          >
                            {camp.banner_image ? (
                              <Image
                                src={camp.banner_image.thumbnail}
                                alt={camp.label}
                                width={40}
                                height={40}
                                preview={false}
                                style={{
                                  objectFit: "cover",
                                  borderRadius: 4,
                                  display: "block",
                                }}
                              />
                            ) : (
                              <div
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {camp.icon}
                              </div>
                            )}
                            <div
                              className="mask"
                              style={{
                                position: "absolute",
                                inset: 0,
                                background: "rgba(0,0,0,0.45)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#fff",
                                opacity: 0,
                                transition: "opacity 0.2s",
                                borderRadius: 4,
                              }}
                            >
                              <ZoomInOutlined style={{ fontSize: 18 }} />
                            </div>
                          </div>
                        </Col>
                        <Col>
                          <Flex
                            gap={2}
                            vertical
                            style={{ margin: 0, padding: 0 }}
                          >
                            <Text
                              type="secondary"
                              ellipsis
                              style={{
                                maxWidth: 240,
                                lineHeight: "1.1em",
                                margin: 0,
                              }}
                            >
                              {camp.name}
                            </Text>
                            <Text
                              type="primary"
                              strong
                              ellipsis
                              style={{
                                fontSize: 12,
                                maxWidth: 200,
                                lineHeight: "1.1em",
                                margin: 0,
                              }}
                            >
                              {camp.value}
                              {camp.action === "discountCart" &&
                                " Desconto no Pedido"}
                              {camp.action === "discountProducts" &&
                                " Desconto em Produtos"}
                              {camp.action === "progressiveDiscount" &&
                                " Desconto Progressivo"}
                            </Text>
                            {camp.end_date && (
                              <Text
                                type="secondary"
                                ellipsis
                                style={{
                                  fontSize: 12,
                                  maxWidth: 200,
                                  lineHeight: "1.1em",
                                  margin: 0,
                                }}
                              >
                                Ativo até: {camp.end_date}
                              </Text>
                            )}
                          </Flex>
                        </Col>
                      </Row>
                      {camp.action && (
                        <Tag
                          color="gold"
                          bordered={false}
                          style={{
                            position: "absolute",
                            bottom: 4,
                            right: 4,
                            fontSize: 10,
                            margin: 0,
                            padding: "0 2px",
                          }}
                        >
                          Campanha
                        </Tag>
                      )}
                    </>
                  )}
                </Card>
              }
            />
          );
        })}
      </Tabs>
    );
  },
);

const Catalogo = React.memo(() => {
  const dispatch = useDispatch();
  const { token } = useToken();
  const screens = useBreakpoint();

  const [visibleCart, setVisibleCart] = useState(false);
  const [visibleOrder, setVisibleOrder] = useState(false);
  const [selectedOption, setSelectedOption] = useState("order");
  const [treeData, setTreeData] = useState([]);
  const [viewType, setViewType] = useState("list");
  const [onSaleCount, setOnSaleCount] = useState(null);
  const [featuredCampaign, setFeaturedCampaign] = useState(null);
  const [allCampaignsModal, setAllCampaignsModal] = useState(false);
  const [activeTab, setActiveTab] = useState("all");

  const buyerView = useSelector((state) => state.buyerView.buyerView);
  const logged = useSelector((state) => state.authentication.logged);
  const onlineStatus = useSelector((state) => state.sync.onlineStatus);
  const syncStatus = useSelector((state) => state.sync.syncStatus);
  const dropdownValue = useSelector((state) => state.searchState.categories);
  const campaigns = useSelector((state) => state.campaigns.campaigns);

  const { orderRebuyId } = useParams();

  useEffect(() => setViewType(screens.md ? viewType : "list"), [screens.md]);

  useEffect(() => {
    buyerView &&
      axiosClient
        .post(
          "/products/search",
          {
            filter: "on_sale",
            only_count: true,
            buyerViewId: buyerView.id,
          },
          { withCredentials: true },
        )
        .then((response) => setOnSaleCount(response?.data?.count || 0));
  }, [buyerView]);

  useEffect(() => {
    if (logged === "buyer") {
      setViewType("card");
    }
  }, [logged]);

  useEffect(() => {
    orderRebuyId && dispatch({ type: "SET_ORDER_REBUY", orderRebuyId });
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    if (params.has("meus-pedidos")) {
      setSelectedOption("order");
      setVisibleOrder(true);
    }

    if (params.has("minhas-contas")) {
      setSelectedOption("bill");
      setVisibleOrder(true);
    }
  }, []);

  const options = [
    {
      label: "Orçamentos",
      value: "quote",
    },
    {
      label: "Pedidos",
      value: "order",
    },
    {
      label: "Contas",
      value: "bill",
    },
    {
      label: "Notas",
      value: "invoice",
    },
  ];

  useEffect(() => {
    axiosClient
      .get("/products/categories/list", { withCredentials: true })
      .then((response) => {
        setTreeData(response.data);
      });
  }, []);

  const defaultFilters = [
    {
      id: "all",
      filterType: "all",
      name: "Todos os Produtos",
      value: "Ver tudo",
    },
    {
      id: "rebuy",
      filterType: "rebuy",
      name: "Últimos Comprados",
      value: "Histórico",
    },
    ...(onSaleCount > 0
      ? [
          {
            id: "on_sale",
            filterType: "on_sale",
            name: "Itens com Desconto",
            value: `${onSaleCount} ${onSaleCount === 1 ? "item" : "itens"}`,
          },
        ]
      : []),
  ];

  return (
    <Layout
      style={{
        backgroundColor: token.customColor2 ?? token.colorBgLayout,
        position: "absolute",
        width: "100%",
        left: "0px",
        top: "0px",
      }}
    >
      {(logged === "seller" || logged === "sellerUser") &&
        (orderRebuyId ? <OrderEditMessage /> : <SellerBuyerView />)}
      <Navbar
        setAllCampaignsModal={setAllCampaignsModal}
        handleToggle={() => setVisibleOrder(true)}
      />
      {!onlineStatus && syncStatus != "synced" && (
        <Result
          style={{ marginTop: "100px" }}
          status="warning"
          title="Você está sem internet e seu aplicativo não está sincronizado"
          subTitle="Conecte seu aparelho na internet e sincronize os dados para usá-lo offline."
        />
      )}
      {(onlineStatus || syncStatus === "synced") && (
        <Content>
          <div
            style={{
              backgroundColor: token.customColor1 ?? token.colorBgContainer,
              borderRadius: token.borderRadius,
              marginTop:
                logged === "seller" || logged === "sellerUser"
                  ? screens.md
                    ? 112 + token.marginXXS
                    : 112
                  : screens.md
                    ? 60 + token.marginXXS
                    : 60,
              width: "100%",
              overflow: "hidden",
            }}
          >
            <Drawer
              title="Seu Pedido"
              placement="right"
              width={window.innerWidth > 375 ? 375 : "100%"}
              onClose={() => setVisibleCart(false)}
              open={visibleCart}
            >
              <Cart />
            </Drawer>
            <Drawer
              title="Histórico do Cliente"
              placement="right"
              width={window.innerWidth > 375 ? 375 : "100%"}
              onClose={() => setVisibleOrder(false)}
              open={visibleOrder}
            >
              <Flex vertical gap="middle">
                <Radio.Group
                  block
                  options={options}
                  value={selectedOption}
                  onChange={(e) => setSelectedOption(e.target.value)}
                  optionType="button"
                  buttonStyle="solid"
                />
              </Flex>
              {["order", "quote"].includes(selectedOption) && (
                <BuyerListOrder orderType={selectedOption} />
              )}
              {selectedOption === "bill" && <BuyerListBill />}
              {selectedOption === "invoice" && <BuyerListInvoice />}
            </Drawer>
            <div
              style={{
                padding: "0px 6px",
                margin: 0,
              }}
            >
              <PromoTabs
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                campaigns={campaigns}
                defaultFilters={defaultFilters}
                token={token}
                dispatch={dispatch}
                setFeaturedCampaign={setFeaturedCampaign}
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: screens.md ? "row" : "column",
                gap: 8,
                padding: "0px 6px",
              }}
            >
              <SearchProduct />
              <TreeSelect
                showSearch
                treeNodeFilterProp="title"
                treeData={treeData}
                value={dropdownValue}
                onChange={(categories) =>
                  dispatch({ type: "CATEGORIES_VALUE", categories })
                }
                showCheckedStrategy={TreeSelect.SHOW_PARENT}
                treeCheckable
                placeholder="Filtre por categorias"
                style={{ width: "100%" }}
                size="large"
                allowClear
              />
              {screens.md && (
                <Segmented
                  size="large"
                  onChange={setViewType}
                  value={viewType}
                  options={[
                    {
                      value: "list",
                      icon: <BarsOutlined />,
                    },
                    {
                      value: "card",
                      icon: <AppstoreOutlined />,
                    },
                  ]}
                />
              )}
            </div>
            <BuyerListProduct viewType={viewType} />
            <CartButton handleToggle={() => setVisibleCart(!visibleCart)} />
          </div>
        </Content>
      )}
      <Modal
        destroyOnHidden
        centered
        width="90%"
        footer={
          <Button key="back" onClick={() => setAllCampaignsModal(null)}>
            Fechar
          </Button>
        }
        title="Campanhas Ativas"
        open={allCampaignsModal}
        onCancel={() => setAllCampaignsModal(false)}
        bodyStyle={{ overflowY: "auto", padding: 16 }}
      >
        <Row gutter={[16, 16]}>
          {(campaigns || [])
            .filter((rule) =>
              [
                "discountCart",
                "freeShipping",
                "progressiveDiscount",
                "discountProducts",
              ].includes(rule.action),
            )
            .map((campaign) => (
              <Col xs={24} md={12} key={campaign.id}>
                <Card
                  hoverable
                  onClick={() => setFeaturedCampaign(campaign)}
                  size="small"
                  title={campaign.name}
                  bodyStyle={{ padding: 8 }}
                >
                  <Row gutter={8} wrap={false} align="middle">
                    {campaign.banner_image?.thumbnail && (
                      <Col
                        flex="80px"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Image
                          src={campaign.banner_image.thumbnail}
                          alt={campaign.name}
                          width={70}
                          height={70}
                          preview={false}
                        />
                      </Col>
                    )}
                    <Col
                      flex="auto"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                      }}
                    >
                      <Typography.Text
                        type="secondary"
                        style={{ fontSize: 11 }}
                      >
                        {campaign.action === "progressiveDiscount"
                          ? "Desconto Progressivo"
                          : campaign.action === "discountProducts"
                            ? "Desconto em Produtos"
                            : campaign.action === "discountCart"
                              ? "Desconto no Carrinho"
                              : "Frete Grátis"}
                      </Typography.Text>
                      {campaign.description && (
                        <Typography.Paragraph
                          ellipsis={{ rows: 2 }}
                          style={{ marginBottom: 0, fontSize: 11 }}
                        >
                          {campaign.description.length > 100
                            ? `${campaign.description.slice(0, 100)}...`
                            : campaign.description}
                        </Typography.Paragraph>
                      )}
                    </Col>
                  </Row>
                </Card>
              </Col>
            ))}
        </Row>
      </Modal>
      <Modal
        destroyOnClose
        centered
        width="90%"
        footer={[
          <Button key="close" onClick={() => setFeaturedCampaign(null)}>
            Fechar
          </Button>,
          (featuredCampaign?.action === "progressiveDiscount" ||
            featuredCampaign?.action === "discountProducts") && (
            <Button
              key="viewProducts"
              type="primary"
              onClick={() => {
                dispatch({
                  type: "SET_FILTER_TYPE",
                  filterType: `campaign_${featuredCampaign.id}`,
                });
                setFeaturedCampaign(null);
                setAllCampaignsModal(false);
                setActiveTab(`campaign_${featuredCampaign.id}`);
              }}
            >
              Ver Produtos
            </Button>
          ),
        ]}
        title="Detalhes da Campanha"
        open={!!featuredCampaign}
        onCancel={() => setFeaturedCampaign(null)}
        bodyStyle={{ maxHeight: "80vh", overflowY: "auto", padding: 16 }}
      >
        {featuredCampaign && (
          <Row gutter={[16, 16]}>
            {featuredCampaign.banner_image?.url && (
              <Col xs={24} md={10}>
                <Card size="small" bodyStyle={{ padding: 0 }}>
                  <Image
                    src={featuredCampaign.banner_image.url}
                    alt={featuredCampaign.name}
                    width="100%"
                    height={360}
                    style={{ objectFit: "cover" }}
                    preview
                  />
                </Card>
              </Col>
            )}

            <Col xs={24} md={featuredCampaign.banner_image?.url ? 14 : 24}>
              <Card size="small">
                <Typography.Title level={3} style={{ marginTop: 0 }}>
                  {featuredCampaign.name}
                </Typography.Title>

                {featuredCampaign.description && (
                  <>
                    <Typography.Paragraph
                      style={{
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                      }}
                    >
                      {featuredCampaign.description}
                    </Typography.Paragraph>
                    <Divider />
                  </>
                )}

                <Descriptions
                  bordered
                  column={1}
                  layout={!screens.md ? "vertical" : "horizontal"}
                  size="small"
                >
                  <Descriptions.Item label="Tipo de Campanha">
                    {featuredCampaign.action === "progressiveDiscount"
                      ? "Desconto Progressivo"
                      : featuredCampaign.action === "discountProducts"
                        ? "Desconto em Produtos"
                        : featuredCampaign.action === "discountCart"
                          ? "Desconto no Carrinho"
                          : featuredCampaign.action === "freeShipping"
                            ? "Frete Grátis"
                            : featuredCampaign.action}
                  </Descriptions.Item>

                  {((featuredCampaign.action === "progressiveDiscount" &&
                    featuredCampaign.progressive_table?.length) ||
                    (featuredCampaign.action === "discountCart" &&
                      (featuredCampaign.order_by_customer ||
                        featuredCampaign.orders_above_value)) ||
                    (featuredCampaign.action === "freeShipping" &&
                      featuredCampaign.orders_above_value)) && (
                    <Descriptions.Item label="Regra de Desconto">
                      {featuredCampaign.action === "progressiveDiscount" && (
                        <List
                          size="small"
                          dataSource={featuredCampaign.progressive_table}
                          renderItem={(item) => (
                            <List.Item>
                              A partir de {item.quantidade} unidades:{" "}
                              {item.porcentagem}% de desconto
                            </List.Item>
                          )}
                        />
                      )}

                      {featuredCampaign.action === "discountCart" && (
                        <>
                          {featuredCampaign.order_by_customer && (
                            <div>Pedido realizado diretamente pelo cliente</div>
                          )}
                          {featuredCampaign.orders_above_value && (
                            <div>
                              Válido para pedidos acima de: R$
                              {featuredCampaign.order_value}
                            </div>
                          )}
                        </>
                      )}

                      {featuredCampaign.action === "freeShipping" &&
                        featuredCampaign.orders_above_value && (
                          <div>
                            Frete grátis para pedidos acima de: R$
                            {featuredCampaign.order_value}
                          </div>
                        )}
                    </Descriptions.Item>
                  )}

                  {(featuredCampaign.discount_value ||
                    featuredCampaign.value_or_percentage) && (
                    <Descriptions.Item label="Desconto">
                      {featuredCampaign.discount_value}
                      {featuredCampaign.value_or_percentage === "percent"
                        ? "%"
                        : " R$"}
                    </Descriptions.Item>
                  )}

                  {((featuredCampaign.products_categories?.length || 0) > 0 ||
                    (featuredCampaign.products?.length || 0) > 0) && (
                    <Descriptions.Item label="Produtos/Categorias">
                      {featuredCampaign.products_categories?.length > 0 && (
                        <div style={{ wordBreak: "break-word" }}>
                          Categorias aplicáveis:{" "}
                          {featuredCampaign.products_categories
                            .map((cat) => cat.title)
                            .join(", ")}
                        </div>
                      )}
                      {featuredCampaign.products?.length > 0 && (
                        <div style={{ wordBreak: "break-word" }}>
                          Produtos aplicáveis:{" "}
                          {featuredCampaign.products
                            .map((p) => p.product_name)
                            .join(", ")}
                        </div>
                      )}
                    </Descriptions.Item>
                  )}

                  <Descriptions.Item label="Validade">
                    {featuredCampaign.end_date || "Indefinida"}
                  </Descriptions.Item>
                </Descriptions>
              </Card>
            </Col>
          </Row>
        )}
      </Modal>
      <PagesFooter />
    </Layout>
  );
});

export default Catalogo;
